var _defs, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _g, _path9, _rect3, _rect4, _rect5, _path10, _path11, _g2, _path12, _path13, _path14, _rect6, _g3, _path15, _g4, _g5, _g6, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 255.436,
    height: 261.664,
    viewBox: "0 0 255.436 261.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2046",
    "data-name": "Rectangle 2046",
    width: 151.664,
    height: 202.325,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2035",
    "data-name": "Rectangle 2035",
    width: 48.111,
    height: 33.151,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2039",
    "data-name": "Rectangle 2039",
    width: 24.585,
    height: 45.826,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2041",
    "data-name": "Rectangle 2041",
    width: 39.927,
    height: 21.629,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2042",
    "data-name": "Rectangle 2042",
    width: 56.724,
    height: 1.791,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2043",
    "data-name": "Rectangle 2043",
    width: 14.928,
    height: 1.791,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2044",
    "data-name": "Rectangle 2044",
    width: 11.884,
    height: 1.791,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6727",
    "data-name": "Group 6727",
    transform: "translate(-840.094 -174.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5415",
    "data-name": "Group 5415",
    transform: "translate(884.336 233.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5414",
    "data-name": "Group 5414",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5413",
    "data-name": "Group 5413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5412",
    "data-name": "Group 5412",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M143.46,282.852l.219-.462h-14.54a20.29,20.29,0,0,1,0,18.154h14.54a20.191,20.191,0,0,1-.219-17.691",
    transform: "translate(-60.576 -132.464)",
    fill: "#d67205"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M143.678,300.544h0a20.191,20.191,0,0,1-.219-17.691l.219-.462h-14.54a20.156,20.156,0,0,1,1.213,3.017c2.571.438,6.134,1.439,7.672,3.7,1.666,2.451,1.852,7.951,1.783,11.438Z",
    transform: "translate(-60.576 -132.464)",
    fill: "#ba6304"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M191.235,60.3h9.484c18.05,0,32.734-15.741,32.734-35.09V8.482c0-5.23-8.107-5.247-8.107,0v3.206a5.74,5.74,0,0,1-5.524,5.921H208.108V13.046h11.714a1.316,1.316,0,0,0,1.267-1.358V8.482c0-11.3,16.62-11.316,16.62,0V25.213c0,21.865-16.594,39.654-36.991,39.654H183.433a38.786,38.786,0,0,0,7.8-4.564",
    transform: "translate(-86.045 0)",
    fill: "#ffc003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M46.474,60.3H36.991c-18.05,0-32.734-15.741-32.734-35.09V8.482c0-5.23,8.107-5.247,8.107,0v3.206a5.74,5.74,0,0,0,5.524,5.921H29.6V13.046H17.887a1.316,1.316,0,0,1-1.267-1.358V8.482C16.62-2.822,0-2.834,0,8.482V25.213C0,47.078,16.594,64.867,36.991,64.867H54.276a38.786,38.786,0,0,1-7.8-4.564",
    transform: "translate(0 0)",
    fill: "#ffcf03"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M200.718,113.581h-9.484a38.79,38.79,0,0,1-7.8,4.564h12.29a48.789,48.789,0,0,0,5.472-4.567q-.237,0-.475,0",
    transform: "translate(-86.045 -53.277)",
    fill: "#ffa303"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2033",
    "data-name": "Rectangle 2033",
    width: 7.851,
    height: 4.563,
    transform: "translate(122.063 13.046)",
    fill: "#ffa303"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2034",
    "data-name": "Rectangle 2034",
    width: 7.851,
    height: 4.563,
    transform: "translate(21.75 13.046)",
    fill: "#ffa303"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M69.253,113.581q-.238,0-.475,0a48.788,48.788,0,0,0,5.472,4.567h12.29a38.79,38.79,0,0,1-7.8-4.564Z",
    transform: "translate(-32.263 -53.277)",
    fill: "#ffa303"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M141.457.525H49.816a7.6,7.6,0,0,0-7.6,7.6H149.054a7.6,7.6,0,0,0-7.6-7.6",
    transform: "translate(-19.805 -0.246)",
    fill: "#ffdc01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M52.213,14.833V32.5A42.517,42.517,0,0,0,91.046,74.778H109.6A42.517,42.517,0,0,0,148.435,32.5V14.833Z",
    transform: "translate(-24.492 -6.958)",
    fill: "#ffb600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5396",
    "data-name": "Group 5396",
    transform: "translate(27.721 22.527)",
    opacity: 0.27,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5395",
    "data-name": "Group 5395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5394",
    "data-name": "Group 5394",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M60.1,42.431c-2.7,0-5.337.11-7.886.32v2.691A42.234,42.234,0,0,0,64.821,75.582c19.99-.966,35.5-7.993,35.5-16.519,0-9.186-18.009-16.632-40.225-16.632",
    transform: "translate(-52.213 -42.431)",
    fill: "#ffb600"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M148.21,14.833V24.62c0,22.174-17.006,41.329-38.833,42.283-4.54.2-13.812.208-18.557,0a36.986,36.986,0,0,1-12.035-2.856A42.525,42.525,0,0,0,103.51,74.778h18.557A42.517,42.517,0,0,0,160.9,32.5V14.833Z",
    transform: "translate(-36.957 -6.958)",
    fill: "#f80"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2036",
    "data-name": "Rectangle 2036",
    width: 17.474,
    height: 10.115,
    transform: "translate(67.095 67.82)",
    fill: "#d67205"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2037",
    "data-name": "Rectangle 2037",
    width: 17.474,
    height: 5.972,
    transform: "translate(67.095 67.82)",
    fill: "#c96b05"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2038",
    "data-name": "Rectangle 2038",
    width: 25.379,
    height: 8.794,
    transform: "translate(63.143 77.934)",
    fill: "#ffcf03"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M142.356,163.356H113.293a2.453,2.453,0,0,0-2.454,2.453v1.922H144.81v-1.922a2.453,2.453,0,0,0-2.454-2.453",
    transform: "translate(-51.993 -76.627)",
    fill: "#ffdc01"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M104.673,171.6l13.293,45.826h14.079L145.191,171.6Z",
    transform: "translate(-49.1 -80.494)",
    fill: "#ff8b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5399",
    "data-name": "Group 5399",
    transform: "translate(55.573 91.105)",
    opacity: 0.47,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5398",
    "data-name": "Group 5398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5397",
    "data-name": "Group 5397",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M117.966,217.425h1.413c5.949-5.736,9.88-15.633,9.88-26.882a42.84,42.84,0,0,0-4.2-18.943H104.673Z",
    transform: "translate(-104.673 -171.599)",
    fill: "#ff8b00"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M137.885,257.913H123.85a6.514,6.514,0,0,0-6.524,6.44h27.083a6.513,6.513,0,0,0-6.524-6.44",
    transform: "translate(-55.036 -120.982)",
    fill: "#ffdc01"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M144.409,270.043H117.325a6.51,6.51,0,0,0,6.524,6.564h14.034a6.51,6.51,0,0,0,6.524-6.564",
    transform: "translate(-55.035 -126.672)",
    fill: "#ff8b00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M140.263,316.583H114.283a4.62,4.62,0,0,0-4.62,4.62v1.573h35.22V321.2a4.619,4.619,0,0,0-4.62-4.62",
    transform: "translate(-51.441 -148.504)",
    fill: "#ffdc01"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2040",
    "data-name": "Rectangle 2040",
    width: 49.008,
    height: 23.347,
    transform: "translate(51.328 174.272)",
    fill: "#ffb600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5402",
    "data-name": "Group 5402",
    transform: "translate(51.328 174.272)",
    opacity: 0.35,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5401",
    "data-name": "Group 5401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5400",
    "data-name": "Group 5400",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M96.678,349.662q2.59.212,5.295.214c19.126,0,34.632-8.26,34.632-18.449a10.2,10.2,0,0,0-.513-3.18H96.678Z",
    transform: "translate(-96.678 -328.247)",
    fill: "#ffb600"
  }))))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M142.024,372.221H91.336a4.255,4.255,0,0,0-4.255,4.255v.451h59.2v-.451a4.255,4.255,0,0,0-4.255-4.255",
    transform: "translate(-40.848 -174.602)",
    fill: "#ffdc01"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5405",
    "data-name": "Group 5405",
    transform: "translate(62.13 3.182)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5404",
    "data-name": "Group 5404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5403",
    "data-name": "Group 5403",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M172.852,7.784H117.918a.9.9,0,0,1,0-1.791h54.934a.9.9,0,1,1,0,1.791",
    transform: "translate(-117.023 -5.993)",
    fill: "#ffed78"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5408",
    "data-name": "Group 5408",
    transform: "translate(43.917 3.182)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5407",
    "data-name": "Group 5407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5406",
    "data-name": "Group 5406",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M96.751,7.784H83.615a.9.9,0,1,1,0-1.791H96.751a.9.9,0,1,1,0,1.791",
    transform: "translate(-82.719 -5.993)",
    fill: "#ffed78"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5411",
    "data-name": "Group 5411",
    transform: "translate(27.721 3.182)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5410",
    "data-name": "Group 5410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5409",
    "data-name": "Group 5409",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M63.2,7.784H53.108a.9.9,0,0,1,0-1.791H63.2a.9.9,0,0,1,0,1.791",
    transform: "translate(-52.213 -5.993)",
    fill: "#ffed78"
  }))))))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M175.619,152.749a5.674,5.674,0,0,1-4.894-2.521.707.707,0,1,1,1.206-.738c1.265,2.07,4.375,2.3,6.309,1.123a7.975,7.975,0,0,0,3.416-6.408,23.329,23.329,0,0,0-1.243-7.842.5.5,0,0,1-.014-.049,9.688,9.688,0,0,1-3.077.6,6.6,6.6,0,0,1-4.454-1.346,4.154,4.154,0,0,1-1.314-4.617,3.538,3.538,0,0,1,2.46-2.04,5.212,5.212,0,0,1,4.382.874,9.283,9.283,0,0,1,2.868,4.542A12.522,12.522,0,0,0,187,124.164c.112-6.155-3.692-11.609-6.9-15.1a.707.707,0,1,1,1.041-.957c3.385,3.681,7.4,9.461,7.275,16.082a13.753,13.753,0,0,1-6.711,11.535c.024.083.047.168.072.252a24.468,24.468,0,0,1,1.292,8.323,9.378,9.378,0,0,1-4.092,7.522,6.46,6.46,0,0,1-3.355.928m-.355-22.585a3.435,3.435,0,0,0-.888.112,2.156,2.156,0,0,0-1.516,1.216,2.755,2.755,0,0,0,.918,2.992,5.16,5.16,0,0,0,3.5,1.014,8.1,8.1,0,0,0,2.7-.553,8.088,8.088,0,0,0-2.455-4.044,3.764,3.764,0,0,0-2.265-.737",
    transform: "translate(907.114 146.61)",
    fill: "#ff41aa"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M240.779,275.868a.707.707,0,0,1-.324-1.336c3.384-1.736,5.447-6.059,5.519-11.565a14.5,14.5,0,0,0-.354-3.606,5.95,5.95,0,0,1-4.426,2.306,4.854,4.854,0,0,1-3.518-1.586,3.856,3.856,0,0,1-1.036-3.064A3.757,3.757,0,0,1,239.13,254a5.448,5.448,0,0,1,5.341.711,6.57,6.57,0,0,1,1.254,1.366c1-3.649-.987-7.634-2.356-9.809-.638-1.015-1.353-2.025-2.046-3a28.551,28.551,0,0,1-4.335-7.715c-1.329-4.224-.1-9.78,4.2-11.394a.707.707,0,1,1,.5,1.323c-3.415,1.281-4.488,6.022-3.347,9.646a27.024,27.024,0,0,0,4.14,7.32c.7.993,1.43,2.019,2.088,3.064,1.663,2.641,4.129,7.733,2.042,12.26a14.112,14.112,0,0,1,.781,5.209c-.079,6.038-2.429,10.825-6.286,12.8a.712.712,0,0,1-.322.078m.416-20.843a4.164,4.164,0,0,0-1.54.29,2.407,2.407,0,0,0-1.612,1.876,2.465,2.465,0,0,0,.687,1.946,3.394,3.394,0,0,0,2.442,1.117,4.854,4.854,0,0,0,3.871-2.538,5.541,5.541,0,0,0-1.468-1.907,3.789,3.789,0,0,0-2.381-.783",
    transform: "matrix(0.839, 0.545, -0.545, 0.839, 978.665, -4.563)",
    fill: "#ffaf00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M240.779,275.868a.707.707,0,0,1-.324-1.336c3.384-1.736,5.447-6.059,5.519-11.565a14.5,14.5,0,0,0-.354-3.606,5.95,5.95,0,0,1-4.426,2.306,4.854,4.854,0,0,1-3.518-1.586,3.856,3.856,0,0,1-1.036-3.064A3.757,3.757,0,0,1,239.13,254a5.448,5.448,0,0,1,5.341.711,6.57,6.57,0,0,1,1.254,1.366c1-3.649-.987-7.634-2.356-9.809-.638-1.015-1.353-2.025-2.046-3a28.551,28.551,0,0,1-4.335-7.715c-1.329-4.224-.1-9.78,4.2-11.394a.707.707,0,1,1,.5,1.323c-3.415,1.281-4.488,6.022-3.347,9.646a27.024,27.024,0,0,0,4.14,7.32c.7.993,1.43,2.019,2.088,3.064,1.663,2.641,4.129,7.733,2.042,12.26a14.112,14.112,0,0,1,.781,5.209c-.079,6.038-2.429,10.825-6.286,12.8a.712.712,0,0,1-.322.078m.416-20.843a4.164,4.164,0,0,0-1.54.29,2.407,2.407,0,0,0-1.612,1.876,2.465,2.465,0,0,0,.687,1.946,3.394,3.394,0,0,0,2.442,1.117,4.854,4.854,0,0,0,3.871-2.538,5.541,5.541,0,0,0-1.468-1.907,3.789,3.789,0,0,0-2.381-.783",
    transform: "translate(624.524 270.977) rotate(-59)",
    fill: "#ffaf00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M267.016,117.316a.706.706,0,0,1-.4-1.288,8.387,8.387,0,0,0,3.157-7.377,13.852,13.852,0,0,0-1.011-4.306,9.652,9.652,0,0,1-4.2.563,7.787,7.787,0,0,1-5.926-3.287,4.623,4.623,0,0,1-.735-4.115,3.59,3.59,0,0,1,1.985-2.028,5.015,5.015,0,0,1,3.821-.03,9.9,9.9,0,0,1,4.3,4.31c.566.93,1.051,1.821,1.462,2.681a6.763,6.763,0,0,0,1.489-1.172c2.852-3.01,3.146-8.253.683-12.2-2.179-3.493-6.243-6-11.146-6.866a.707.707,0,0,1-.573-.82.7.7,0,0,1,.819-.571c5.3.94,9.708,3.676,12.1,7.508,2.791,4.471,2.422,10.453-.857,13.916a8.24,8.24,0,0,1-1.94,1.509,15.3,15.3,0,0,1,1.137,4.82,9.682,9.682,0,0,1-3.767,8.624.707.707,0,0,1-.4.124M261.834,96.5a3.449,3.449,0,0,0-1.38.279,2.18,2.18,0,0,0-1.223,1.217,3.293,3.293,0,0,0,.584,2.843,6.389,6.389,0,0,0,4.87,2.664,8.308,8.308,0,0,0,3.505-.462c-.389-.813-.851-1.659-1.39-2.545a8.664,8.664,0,0,0-3.635-3.739,3.463,3.463,0,0,0-1.331-.257",
    transform: "translate(609.623 253.287)",
    fill: "#ff0e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M94.444,160.409a.707.707,0,0,1-.214-1.38,10.347,10.347,0,0,0,7.032-8.877,9.7,9.7,0,0,0-.027-1.743,10.737,10.737,0,0,1-10.42-2.607c-1.4-1.434-2.373-3.712-1.384-5.568,1.212-2.272,4.438-2.392,6.861-1.191a11.794,11.794,0,0,1,6.019,7.473,8.906,8.906,0,0,0,.9-.478,11.292,11.292,0,0,0,5.093-10.708c-.465-4.588-3.307-8.335-6.315-12.3-2.918-3.849-5.936-7.828-6.579-12.656a14.47,14.47,0,0,1,6.756-13.977.706.706,0,0,1,.724,1.213,13.021,13.021,0,0,0-6.077,12.577c.594,4.458,3.367,8.116,6.3,11.989,2.993,3.948,6.089,8.031,6.595,13.014a12.733,12.733,0,0,1-5.768,12.061,10.623,10.623,0,0,1-1.349.687,10.914,10.914,0,0,1,.072,2.325,11.79,11.79,0,0,1-8.013,10.117.716.716,0,0,1-.215.033m-1.3-20.709a2.63,2.63,0,0,0-2.465,1.2c-.653,1.225.106,2.848,1.147,3.914A9.443,9.443,0,0,0,100.981,147a10.353,10.353,0,0,0-5.318-6.692,5.822,5.822,0,0,0-2.518-.609",
    transform: "translate(751.624 111.068)",
    fill: "#00d339"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M92.949,276.155a5.572,5.572,0,0,1,1.033,2.117,17.289,17.289,0,0,1,3.76-2.79,3.116,3.116,0,0,0-.769-2.139,20.472,20.472,0,0,0-4.024,2.811",
    transform: "translate(802.555 115.456)",
    fill: "#ffaf00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M210.927,101.173a10.739,10.739,0,0,0-6.6,1.485,16.02,16.02,0,0,1-1.845,4.529c1.572-.342,2.542.2,4.119,1.858.769-2.658,2.269-4.879,4.328-7.871",
    transform: "translate(834.493 109.965)",
    fill: "#00d339"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M95.819,154.248A2.919,2.919,0,0,0,97.03,156.9a4.433,4.433,0,0,0,2.625-1.2,6.623,6.623,0,0,1,.22-3.666,11.494,11.494,0,0,1-4.056,2.211",
    transform: "translate(744.28 131.873)",
    fill: "#00d339"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M193.056,91.462a4.793,4.793,0,0,0-2.843,1,7.125,7.125,0,0,1-.579,2.1c.677-.232,1.135-.046,1.921.608a12.39,12.39,0,0,1,1.5-3.712",
    transform: "translate(827.617 104.773)",
    fill: "#008df0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M104.121,114.782a3.12,3.12,0,0,0,2.2-.106,19.639,19.639,0,0,1-.547-7.051,3.219,3.219,0,0,1-2.079-.213,17.463,17.463,0,0,0,.422,7.371",
    transform: "translate(791.576 96.184)",
    fill: "#ff41aa"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M232.3,112.625a6.767,6.767,0,0,0-5.641-1.013,41.7,41.7,0,0,1-3.745,9.1,6.2,6.2,0,0,1,2.963,1.118,37.187,37.187,0,0,1,6.422-9.209",
    transform: "translate(845.433 115.44)",
    fill: "#008df0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M96.816,230.8a13.163,13.163,0,0,0,4.075-2.148,5.291,5.291,0,0,0-2.248-1.672,4.4,4.4,0,0,1-2.475,1.359,2.967,2.967,0,0,1,.648,2.461",
    transform: "translate(804.277 90.638)",
    fill: "#ff0e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M279.229,163.08a7.507,7.507,0,0,1-1.1,5.252c3.54.15,7.1-.1,8.624-.723a12.012,12.012,0,0,0-.814-5.091c-1.713.725-3.576.706-6.708.562",
    transform: "translate(721.17 189.828)",
    fill: "#00d339"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M153.707,105.59a5.967,5.967,0,0,0,.513,5.941c2.415.4,4.208.353,5.879-.507.241-2.6,1.142-4.248,2.942-6.912a23.526,23.526,0,0,1-9.333,1.477",
    transform: "translate(709.416 161.114)",
    fill: "#ff41aa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.54be5698b1e09b235fec94d39e9e0fd0.svg";
export { ForwardRef as ReactComponent };